import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityAmount from 'apps/auth/components/ga/activity/components/ActivityAmount';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { getGaActivityDate } from 'apps/auth/helpers/utils';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';

const TopUpDetails = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const getStatusText = () => {
        let statusText = props.chequeStatusInProgress;
        if (mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = props.chequeStatusCanceled;
        } else if (mobileInfo.stsId > STATUS_OK) {
            statusText = mobileInfo.stsName;
        }
        if (statusText) {
            return statusText;
        }
    };

    const getAmount = () => {
        if (mobileInfo.curRate) {
            return (
                <>
                    <ActivityAmount options={props.options} item={item} useArrow />
                    <ActivityAmount options={props.options} item={item} baseColor="primary" isFrom={false} />
                </>
            );
        }
        return <ActivityAmount options={props.options} item={item} baseColor="primary" />;
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent={mobileInfo.stsId !== STATUS_OK && !item.comment ? 'adaptive-24-32' : null}>
                {getAmount()}
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus status={mobileInfo.stsId} comment={item.comment} text={getStatusText()} />
            </Row>
            {mobileInfo.errorMessage && <div>{mobileInfo.errorMessage}</div>}

            <Separator marginTop="48px" marginBottom="48px" />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
                {item.extra?.from_bank_name && (
                    <TableRow title={props.usingText} textColor={textColor} titleColor={titleColor}>
                        {item.extra?.from_bank_name}
                    </TableRow>
                )}
                <TableRow title={props.chequeFee} textColor={textColor} titleColor={titleColor}>
                    {getLocalizedRawAmount(lang, country, mobileInfo.feeUp)} {mobileInfo.frCurIso}
                </TableRow>
            </TableContainer>

            {mobileInfo.curRate && (
                <>
                    <Separator marginTop="48px" marginBottom="48px" />
                    <TableContainer>
                        <TableRow title={props.chequeFee} textColor={textColor} titleColor={titleColor}>
                            {getLocalizedRawAmount(lang, country, mobileInfo.feeUp)} {mobileInfo.frCurIso}
                        </TableRow>
                        <TableRow title={props.chequeFxRate} textColor={textColor} titleColor={titleColor}>
                            {`${getLocalizedRawAmount(lang, country, 1)} ${mobileInfo.frCurIso} = ${getLocalizedRawAmount(lang, country, mobileInfo.curRate, 4)} ${mobileInfo.toCurIso}`}
                        </TableRow>
                    </TableContainer>
                </>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeStatusCanceled: state.messages.pageMessages.chequeStatusCanceled,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    usingText: state.messages.pageMessages.usingText,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(TopUpDetails);
